import {toast} from 'react-toastify';

const INITIAL_STATE = {
  mensagem: "",
  erro: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){ 

    // FALTOU_PREENCHER_CAMPOS_EMAIL
    // ENVIADO_EMAIL
    // SEM_PERMISSAO_EMAIL

    case 'ERRO_EMAIL':
      toast.error(action.erro.message, 5000);
      return {...state, erro: action.erro};
    case 'ENVIAR_EMAIL':
      return {...state, mensagem: "Enviando email..."};
    case 'ENVIADO_EMAIL':
      toast.success("E-mail enviado com sucesso!", 5000);
      return {...state, mensagem: "Email enviado com suceso!"};
    case 'FALTOU_PREENCHER_CAMPOS_EMAIL':
      toast.error("E-mail do destinatário, assunto ou corpo do e-mail não foi preenchido!", 5000);
      return {...state, mensagem: "Email enviado com suceso!"};
    case 'SEM_PERMISSAO_EMAIL':
      toast.error("E-mail não enviado por falta de permissão!", 5000);
      return {...state, mensagem: "Email enviado com suceso!"};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/EmailReducer.js